import styled from 'styled-components';
import { BreadcrumbsStyled } from '../BreadcrumbsStyled';

export const BreadcrumbsOV = styled(BreadcrumbsStyled)`
    a {
        &:hover {
            color: ${({ theme }) => theme.colors.primary};
        }
    }
    span,
    a {
        ::before {
            color: ${({ theme }) => theme.colors.secondary};
            content: '→';
        }
    }
`;
